import { useQuery } from '@tanstack/react-query'
import { photosService } from '@/api/services/photos.service'
import { queryKeys } from '@/api/query-keys'

export function usePhotoPez(pezId: string | null | undefined, enabled = true) {
  const id = pezId?.trim() ? pezId.trim() : null

  return useQuery({
    queryKey: queryKeys.photos.pez(id),
    queryFn: () => photosService.getPhotoPez(id!),
    enabled: enabled && id != null,
    staleTime: 0,
    retry: false,
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
  })
}
